import { TypeformIcon } from '../../../assets/icons/typeform';
import { createEmbedProvider } from '../factory';

/**
 * Typeform URL regex pattern
 * Matches: subdomain.typeform.com/to/FORM_ID
 * Captures the subdomain in group 1 and form ID in group 2.
 */
export const TYPEFORM_REGEX =
  /^https:\/\/([A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)\.typeform\.com\/to\/([^/?#]+)/i;

export const typeformProvider = createEmbedProvider({
  id: 'typeform',
  label: 'Typeform',
  icon: <TypeformIcon className="size-5" />,
  regex: TYPEFORM_REGEX,
  buildEmbedUrl: (match) => `https://${match[1]}.typeform.com/to/${match[2]}`,
});
